<template>
  <v-app>
    <v-container class="my-6 mx-auto">
      <v-card class="py-0">
        <div class="card-header-padding">
          <v-row class="mb-0">
            <v-col cols="auto">
              <div>
                <h5 class="font-weight-bold text-h5 text-typo mb-0">
                  Ангийн xичээлийн жагсаалт  <span v-if="myDepartment">({{ myDepartment.name
                  }}{{ myClass.name.toUpperCase() }})</span>
                </h5>
                <p class="text-sm text-body mb-0">
                  Xичээлийн мэдээллийг удирдаx
                </p>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="card-header-padding">
          <v-simple-table class="bborder">
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    style="
                      border-right: 0px !important;
                      border-left: 1px solid #bbb;
                    "
                  >
                    No
                  </th>
                  <th style="width:10%">Xичээлийн нэр</th>
                  <th style="width:10%">Xичээлийн төрөл</th>
                  <th>Үүссэн эсэx</th>
                  <th>Багшийн нэр</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(categoryLesson, lindex) in allCategories2"
                  :key="categoryLesson.id + lindex"
                >
                  <td
                    style="
                      border-left: 1px solid #bbb;
                      border-right: 0 !important;
                      width: 1%;
                    "
                  >
                    {{ lindex + 1 }}
                  </td>
                  <td style="width: 30%">
                    {{ categoryLesson.name }}
                  </td>
                  <td>  <strong v-if="categoryLesson.lessonType==1">{{categoryLesson.lessonTypeName}}</strong>
                  <span v-else>{{categoryLesson.lessonTypeName}}</span>
                  
                  </td>
                  <td v-if="isLessonCreated(categoryLesson)">
                    <v-btn
                      @click="_gotoLesson(categoryLesson)"
                      small
                      class="
                        border-radius-sm
                        shadow-none
                        font-weight-bold
                        btn-warning
                        bg-gradient-warning
                      "
                      elevation="0"
                      :ripple="false"
                      >xичээл үүссэн</v-btn
                    >
                  </td>

                  <td v-else><span>-</span></td>
                  <td v-if="categoryLesson.lesson">
                    <span class="font-weight-bold">{{ categoryLesson.lesson.teacherFirstName }}</span>,
                    {{ categoryLesson.lesson.teacherLastName }}
                  </td>
                  <td v-else></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
// const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
export default {
  components: {},
  data: () => ({
    query: null,
    path: null,
    headerNames: null,
    bodyNames: null,
    school: null,
    allCategories: null,
    classLessons: null,
    addd: false,
    myClass: null,
    myDepartment: null,
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    allCategories2() {
      var list = [];
      if (this.allCategories) {
        for (var category of this.allCategories) {
          if (category.classGroups) {
            for (var classGroup of category.classGroups) {
              if (classGroup.index == 12) {
                list.push(category);
                break;
              }
            }
          }
        }
      }
      return list;
    },
  },
  created() {
    this.userData["myClassRef-" + this.userData.school.currentYear]
      .get()
      .then((doc) => {
        let myClass = doc.data();
        myClass.id = doc.id;
        myClass.ref = doc.ref;
        myClass.ref.parent.parent.get().then((doc) => {
          let myDep = doc.data();
          myDep.id = doc.id;
          myDep.ref = doc.ref;
          this.myDepartment = myDep;
        });
        this.myClass = myClass;
      });

    this.userData.school.ref
      .collection("lessons")
      .where(
        "classGroupRefs",
        "array-contains",
        this.userData["myClassRef-" + this.userData.school.currentYear]
      )
      .orderBy("name", "asc")
      .onSnapshot((querySnapshot) => {
        this.classLessons = [];
        querySnapshot.forEach((doc) => {
          let lesson = doc.data();
          lesson.id = doc.id;
          lesson.ref = doc.ref;
          this.classLessons.push(lesson);
        });
      });

    this.userData.school.ref
      .collection("categories")
      .orderBy("name", "asc")
      .onSnapshot((querySnapshot) => {
        this.allCategories = [];
        querySnapshot.forEach((doc) => {
          let categoryLesson = doc.data();
          categoryLesson.id = doc.id;
          categoryLesson.ref = doc.ref;
          categoryLesson.classGroups = null;
          categoryLesson.ref
            .collection("departments-" + this.userData.school.currentYear)
            .onSnapshot((docs) => {
              categoryLesson.classGroups = [];
              docs.forEach((doc) => {
                let department = doc.data();
                department.id = doc.id;
                department.ref = doc.ref;
                categoryLesson.classGroups.push(department);
              });
            });
          this.allCategories.push(categoryLesson);
        });
      });
  },
  methods: {
    _gotoLesson(categoryLesson) {
      this.$router.push({
        name: "PageLesson",
        params: {
          path: categoryLesson.lesson.ref.path,
        },
      });
    },
    isLessonCreated(categoryLesson) {
      if (categoryLesson && this.classLessons) {
        for (const lesson of this.classLessons) {
          if (categoryLesson.ref.path == lesson.categoryRef.path) {
            categoryLesson.lesson = lesson;
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>
<style>
.bborder {
  border-bottom: 1px solid #bbb;
}
.bborder td {
  border-right: 1px solid #bbb !important;
}
.bborder th {
  border-right: 1px solid #bbb;
  border-top: 1px solid #bbb;
}
</style>
